import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { NavLink} from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import { Flex, Divider, Text, Heading, View, Button, SelectField} from '@aws-amplify/ui-react';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import Loadingmini from '../components/loadingmini';

const DOC_TYPE_LABELS = {
  license_front: "license front",
  license_back: "license back",
  selfie: "selfie",
};

function missingDocMessage(docType, apiMessage) {
  if (apiMessage && typeof apiMessage === "string" && apiMessage.trim()) {
    return apiMessage.trim();
  }
  const label = DOC_TYPE_LABELS[docType] || "document";
  return `No ${label} on file for this driver.`;
}

export default function Userdocs({userJwt, userId, fleetCode}) {
  const [is_loading, updateIsLoading] = React.useState(false);
  const [count, setCount] = useState(0);
  const [docType, setDocType] = useState("license_front");
  const [presignedUrl, updatePresignedUrl] = useState("");
  const [docNotice, updateDocNotice] = useState("");
  const [res, updateRes] = useState({status:"Contact support if this message stays for more than 30 seconds",rows:[], message:""})
  const columns = [
        {
            headerName: 'Date time',
            field: 'sql_timestamp',
            filter: true
        },
        {
            headerName: 'File',
            width: 400,
            field: 'local_key',
            cellRenderer: params => {
                let val = params.value
                return( <Text><Button style={{border:'none', color:'#0000EE', fontWeight: 'normal', fontStyle: 'italic', marginLeft:'-15px'}} onClick={() => viewDocument(val)}>PREP FILE FOR DOWNLOAD</Button></Text>)
            }
        }
  ];
  
  async function selectDocType(newDocType)
  {
    updatePresignedUrl("")
    updateDocNotice("")
    setDocType(newDocType)
    setCount(count + 1)
  }

  async function fetchPageData(tSelectedFleet) {
    if(userId > 0)
    {
        updateIsLoading(true)
        updateDocNotice("")
        updateRes({status:"loading...",rows:[], message:""})
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": userJwt,
            "api_endpoint":"api3:portal:driver_desk",
            "section":"docs",
            "driver_id":userId,
            "doc_type":docType,
            "fleet_code":fleetCode
        }};
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            //console.log('driverimageslicensefront user ' + userId + ' : ' + JSON.stringify(res))
            const rows = Array.isArray(res?.rows) ? res.rows : []
            updateRes({...res, rows})
            const apiMessage = (res?.message && String(res.message).trim()) || ""
            if (rows.length === 0) {
              updateDocNotice(missingDocMessage(docType, apiMessage))
            } else if (apiMessage) {
              updateDocNotice(apiMessage)
            } else {
              updateDocNotice("")
            }
            updateIsLoading(false)
        }
        catch (e) {
            console.log('userdocs error: '+toString(e));
            updateDocNotice("Could not load driver documents. Please try again.")
            updateIsLoading(false)
        }
        updateIsLoading(false)
    }
  }

  async function viewDocument(docFileName) {
    if(userId > 0)
    {
        if (!docFileName) {
          updatePresignedUrl("")
          updateDocNotice(missingDocMessage(docType))
          return
        }
        updateIsLoading(true)
        updateDocNotice("")
        const myInit = {queryStringParameters:{ 
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt": userJwt,
            "api_endpoint":"api3:portal:driver_desk",
            "section":"docs",
            "driver_id":userId,
            "doc_type":docType,
            "doc_file_name":docFileName,
            "fleet_code":fleetCode
        }};
        //console.log('docFileName: '+ docFileName)
        try {
            const res = await API.get('adminWebTools','/ago',myInit)
            //console.log('driverimageslicensefront user ' + userId + ' : ' + JSON.stringify(res))
            //updateRes(res)
            updateIsLoading(false)
            const url = res?.presigned_url || ""
            updatePresignedUrl(url)
            if (!url) {
              updateDocNotice(missingDocMessage(docType, res?.message))
            }
            
        }
        catch (e) {
            console.log('userdocs error: '+toString(e));
            updatePresignedUrl("")
            updateDocNotice("Could not prepare that document for download. Please try again.")
            updateIsLoading(false)
        }
        updateIsLoading(false)
    }
  }
  useEffect(() => {
    fetchPageData()
    },[count, userId, userJwt, fleetCode])



  return (
      <Flex
        direction="column"
      >
        <View style={{padding:"1rem"}}>
            <Divider />
            {
                is_loading ? <Loadingmini /> : 
                <Flex 
                    direction='column'
                >
                    <Heading level={2}>Driver Docs</Heading>
                    <Text style={{width:'100%'}}>Do not make copies of this data. Select a type of document to view a list of all the uploads of that document type for this driver.</Text>
                    <SelectField
                        label="Document Type"
                        descriptiveText="What document type would you like to see?"
                        onChange={(e) => selectDocType(e.target.value)}
                        value={docType}
                    >
                        <option value="license_front">License Front</option>
                        <option value="license_back">License Back</option>
                        <option value="selfie">Selfie</option>
                    </SelectField>
                    <View>
                        <Button onClick={() => setCount(count + 1)}>
                            PRESS TO GET LATEST UPDATES
                        </Button>
                    </View>
                    <Divider />
                    {
                      docNotice ? (
                        <Text style={{width:'100%', marginBottom:'0.5rem'}}>{docNotice}</Text>
                      ) : null
                    }
                    {
                      Array.isArray(res.rows) && res.rows.length > 0 ? (
                        <Text><i>Hint: To download a document, click PREP FILE FOR DOWNLOAD, then DOWNLOAD SELECTED DOCUMENT.</i></Text>
                      ) : null
                    }
                    <View style={{width:"100%"}}>
                        <View 
                            theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                            style={{ height: 250 }} // the grid will fill the size of the parent container
                        >
                                <AgGridReact
                                    rowData={Array.isArray(res.rows) ? res.rows : []}
                                    columnDefs={columns}
                                    rowSelection={multiRowSelection}
                                    paginationPageSize={250}
                                    paginationPageSizeSelector={[10, 25, 50]}
                                    enableCellTextSelection={true}
                                    rowHeight={50}
                                />
                        </View>
                    </View>
                    <Divider />
                    <View>
                        {
                            presignedUrl ? 
                            presignedUrl !== "" ?
                            <Text><a href={presignedUrl} target='_blank'>DOWNLOAD SELECTED DOCUMENT</a></Text>
                            : <Text>No document selected</Text>
                            : <Text>No document selected</Text>
                        }
                    </View>

                </Flex>
            }
        </View>
      </Flex>
  );
}
